import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { Stethoscope, Sparkles, GraduationCap, Compass } from 'lucide-react';
const audiences = [{
  icon: Stethoscope,
  title: 'Psicólogos Clínicos',
  desc: 'Que sienten que el modelo tradicional se queda corto en el cuerpo y el alma, y buscan integrar la multidimensionalidad con rigor clínico.'
}, {
  icon: Sparkles,
  title: 'Terapeutas y Consteladores',
  desc: 'Que quieren estructurar sus sesiones individuales con bases psicológicas sólidas para dar mayor seguridad y profesionalismo a sus consultantes.'
}, {
  icon: GraduationCap,
  title: 'Estudiantes y Profesionales de la Ayuda',
  desc: "Que desean iniciar su consulta con un método probado 'llave en mano', evitando años de ensayo y error."
}, {
  icon: Compass,
  title: 'Coaches y Mentores',
  desc: 'Que buscan ir al origen transgeneracional y sistémico del dolor del cliente en lugar de quedarse solo en la motivación superficial.'
}];
export const ForWhom = () => {
  return <section className="py-24 bg-navy relative text-cream" data-id="element-96">
      <div className="absolute inset-0 bg-noise opacity-20 pointer-events-none" data-id="element-97"></div>
      <div className="container mx-auto px-6 relative z-10" data-id="element-98">
        <SectionHeading title="¿PARA QUIÉN ES?" subtitle="Diseñado para vos si querés llevar tu práctica terapéutica al próximo nivel de efectividad:" dark data-id="element-99" />

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-100">
          {audiences.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: i % 2 === 0 ? -20 : 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: i * 0.1
        }} className="flex gap-6 p-6 rounded-sm border border-gold-500/20 bg-navy-800/50 backdrop-blur-sm hover:border-gold-500/50 transition-colors" data-id="element-101">
              <div className="flex-shrink-0" data-id="element-102">
                <div className="w-14 h-14 rounded-full bg-gold-500/10 border border-gold-500/30 flex items-center justify-center" data-id="element-103">
                  <item.icon className="w-7 h-7 text-gold-400" data-id="element-104" />
                </div>
              </div>
              <div data-id="element-105">
                <h3 className="font-serif font-bold text-2xl mb-2 text-gold-300" data-id="element-106">
                  {item.title}
                </h3>
                <p className="text-cream-200/80 leading-relaxed" data-id="element-107">{item.desc}</p>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mt-16" data-id="element-108">
          <p className="text-gold-400 italic font-serif text-xl" data-id="element-109">
            ¿No estás seguro de si es para vos? Tenés 7 días de garantía total.
          </p>
        </div>
      </div>
    </section>;
};